<template>
  <div class="container">
    <!-- 服务顾问弹窗 -->
    <div class="dialog">
      <div class="avatar-wrapper">
        <img :src="adviser.avatar" class="avatar" alt="" />
      </div>
      <div class="name">{{ adviser.guideName }}</div>
      <div class="shopname">{{ adviser.networkName }}</div>
      <Qrcode class="qrcode" :src="adviser.qrCodeUrl || 'https://market-cdn.anoah.com/dm/static/market-h5-smartguide/guide_code_error.png'" :tracker="tracker" :meta="meta" />
      <div class="qrcode-hint">长按识别二维码，添加服务顾问的企业微信</div>
    </div>
  </div>
</template>
<script>

import { PAGE_EXPOSE } from "../../../utils/bigDataSdk";
import Qrcode from '../../../components/Qrcode.vue'

const pageInfo = {
  pageId: "40004",
  pageName: "导购企微二维码页",
  pageTilte: "报名成功",
}

export default {
  data: () => {
    return {};
  },
  components:{
    Qrcode
  },
  props: {
    tracker: Function,
  },
  mounted() {
    setTimeout(() => {
      this.tracker({
        eventKey: PAGE_EXPOSE,
        ...pageInfo,
      });
    }, 0);
  },
  computed: {
    adviser() {
      return this.$store.state.activity.adviser || {};
    },
    meta(){
      return  {
        channel:'h5',
        buttonName: '二维码长按',
        buttonContent: '二维码长按'
      };
    }
  },
   
};
</script>
<style lang="scss" scoped>
.container {
  background: url(../../../assets/bg.png) no-repeat 46%;
  position: absolute; 
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog {
  width: 275px;
  height: 350px;
  background: #ffffff;
  box-shadow: -5px 9px 10px 0px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}
.avatar-wrapper {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  width: 66px;
  height: 66px;
  border-radius: 50%;

}
.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  // margin-top: 20px;
  background: url(../../../assets/man-avatar.png);
  background-position: center center;
  background-size: 60px 60px;
}
.name {
  margin-top:30px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.shopname {
  font-size: 14px;
  color: #999;
}
.qrcode {
  margin-top: 20px;
  width: 150px;
  height: 150px;
}
.qrcode-hint {
  margin-top: 15px;
  font-weight: 500;
  color: #999999;
  font-size: 13px;
}
</style>
